export default __webpack_public_path__ + "static/media/av1.af160f99.jpg";